import { LoginRadiusWidget, LRWidgetType } from './base';

export class ForgotPasswordWidget extends LoginRadiusWidget<any, any> {
    constructor(container: string, lrObject: any) {
        super(container);
        this.widgetType = LRWidgetType.FORGOT_PASSWORD;
        this.lrObject = lrObject;
    }
}
